import React, { useEffect, useState } from 'react';
import { InternalFieldName, useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomButton from '../CustomButton/CustomButton';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';
import { UserFormFields } from './UserForm';

interface UserFinancialProps {
  id: number;
  formFields: UserFormFields;
  refreshUser: () => Promise<any>;
}

export interface UserFinancialFormFields {
  paymentValue: number;
}

function addServerErrors<T>(
  errors: { [P in keyof T]?: string[] },
  setError: any
) {
  return Object.keys(errors).forEach((key) => {
    setError(key as keyof T, {
      type: 'server',
      message: errors[key as keyof T]!.join('. '),
    });
  });
}

export default function UserFinancial({
  id,
  formFields,
  refreshUser,
}: UserFinancialProps) {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});
  const {
    register,
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = useForm<UserFinancialFormFields>();

  const onSubmit = async (data: UserFinancialFormFields) => {
    try {
      await api.patch(
        `admin/organizations/${organization.id}/users/${id}/financial`,
        { paymentValue: data.paymentValue }
      );

      refreshUser();
      toast.success('O Valor foi salvo com sucesso');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    reset(formFields);
  }, [formFields]);

  useEffect(() => {
    let shouldFocus = true;
    Object.keys(formErrors || {}).forEach((field: InternalFieldName) => {
      addServerErrors(formErrors, setError);

      shouldFocus = false;
    });
  }, [formErrors]);

  return (
    <form>
      <div className='mb-3 row'>
        <div className='col-md-6'>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor='inputLabel' className='form-label'>
            Valor a pagar por Ordem de Serviço
          </label>
          <input
            {...register('paymentValue', { required: true })}
            className='form-control'
            placeholder='Valor a pagar por Ordem de Serviço'
            type='number'
            required
          />
          {errors.paymentValue && (
            <div className='form-text text-danger'>
              {errors.paymentValue.message}
            </div>
          )}
        </div>
      </div>
      <div className='d-flex justify-content-end gap-2'>
        <Link to='/admin/users' className='btn btn-secondary'>
          Cancelar
        </Link>
        <CustomButton
          type='submit'
          className='btn btn-primary'
          handleClick={handleSubmit(onSubmit)}
        >
          Salvar
        </CustomButton>
      </div>
    </form>
  );
}
